"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_NAME = exports.CURRENCY_MAP = exports.SINGLE_LANGUAGE_DEFAULT = exports.SINGLE_LANGUAGE_MAP = exports.SINGLE_LANGUAGE_COUNTRIES = exports.LANGUAGE_CODES = exports.LANGUAGE_MAP = exports.LOCALE_PATH_REGEX = exports.LOCALE_MAP = void 0;
/** Map of BCP 47 language codes to locale `{country}(/{language})` paths. */
exports.LOCALE_MAP = {
    'en-US': 'us',
    'en-AU': 'au',
    'en-NZ': 'nz',
    'en-SG': 'sg',
    'en-GB': 'uk',
    'fr-FR': 'fr/fr',
    'en-FR': 'fr/en',
    'es-FR': 'fr/es',
    'en-CA': 'ca/en',
    'fr-CA': 'ca/fr',
    'en-HK': 'hk/en',
    'zh-Hant-TW': 'tw',
    'zh-Hant-HK': 'hk/zh_hant',
    'de-DE': 'de/de',
    'en-DE': 'de/en',
    'ja-JP': 'jp',
    'ko-KR': 'kr',
    'it-IT': 'it',
    'en-DK': 'dk',
    'en-SE': 'se',
    'en-NO': 'no',
    'de-CH': 'ch/de',
    'fr-CH': 'ch/fr',
    'en-CH': 'ch/en',
};
/** Array of locale `{country}(/{language})` paths from {@link LOCALE_MAP} values. */
const LOCALE_PATHS = Object.freeze(Object.values(exports.LOCALE_MAP));
/**
 * Regular expression to match locale path from start of URL pathname.
 * Note: NOT case-sensitive. Typical .exec() result:
 * - `[0]: /ch/de`
 * - `[1]: ch/de`
 */
exports.LOCALE_PATH_REGEX = new RegExp(`^/(${LOCALE_PATHS.join('|')})(?=/|$)`, 'i');
/** Map of locale `{country}(/{language})` paths to BCP 47 language codes. Swaps {@link LOCALE_MAP} keys and values. */
exports.LANGUAGE_MAP = Object.fromEntries(Object.entries(exports.LOCALE_MAP).map(([key, value]) => [value, key]));
/** Array of BCP 47 language codes from {@link LOCALE_MAP} keys. */
exports.LANGUAGE_CODES = Object.freeze(Object.values(exports.LANGUAGE_MAP));
/** Filters out {@link LOCALE_PATHS} with multiple segments. */
exports.SINGLE_LANGUAGE_COUNTRIES = Object.freeze(LOCALE_PATHS.filter((path) => !path.includes('/')));
/**
 * Used for country sites with a single non-English language.
 * If a country key ({@link SingleLanguageCountryKey}) is not in this map,
 * default to `en` ({@link SINGLE_LANGUAGE_DEFAULT}) language value.
 */
exports.SINGLE_LANGUAGE_MAP = {
    jp: 'ja',
    kr: 'ko',
    it: 'it',
    tw: 'zhHantTw',
};
exports.SINGLE_LANGUAGE_DEFAULT = 'en';
/**
 * Map of BCP 47 language codes to `{code,symbol}` currencies.
 * @todo in TS v4.9 declare as const while checking type using 'satisfies' operator.
 */
exports.CURRENCY_MAP = {
    'en-US': { code: 'USD', symbol: '$' },
    'en-AU': { code: 'AUD', symbol: '$' },
    'en-NZ': { code: 'NZD', symbol: '$' },
    'en-SG': { code: 'SGD', symbol: '$' },
    'en-GB': { code: 'GBP', symbol: '£' },
    'fr-FR': { code: 'EUR', symbol: '€' },
    'en-FR': { code: 'EUR', symbol: '€' },
    'es-FR': { code: 'EUR', symbol: '€' },
    'en-CA': { code: 'CAD', symbol: '$' },
    'fr-CA': { code: 'CAD', symbol: '$' },
    'en-HK': { code: 'HKD', symbol: '$' },
    'zh-Hant-TW': { code: 'TWD', symbol: 'NT$' },
    'zh-Hant-HK': { code: 'HKD', symbol: '$' },
    'de-DE': { code: 'EUR', symbol: '€' },
    'en-DE': { code: 'EUR', symbol: '€' },
    'ja-JP': { code: 'JPY', symbol: '¥' },
    'ko-KR': { code: 'KRW', symbol: '₩' },
    'it-IT': { code: 'EUR', symbol: '€' },
    'en-DK': { code: 'DKK', symbol: 'kr' },
    'en-SE': { code: 'SEK', symbol: 'kr' },
    'en-NO': { code: 'NOK', symbol: 'kr' },
    'de-CH': { code: 'CHF', symbol: 'CHF' },
    'fr-CH': { code: 'CHF', symbol: 'CHF' },
    'en-CH': { code: 'CHF', symbol: 'CHF' },
};
exports.LANGUAGE_NAME = {
    en: 'English',
    ja: 'Japanese',
    ko: 'Korean',
    zhHantTw: 'Taiwan Chinese',
    de: 'German',
    fr: 'French',
    it: 'Italian',
    // eslint-disable-next-line camelcase
    zh_hant: 'Traditional Chinese',
    es: 'Spanish',
    th: 'Thailand',
};
//# sourceMappingURL=locales.js.map